import { writable } from 'svelte/store';

interface ModalInterface {
  modalName: string,
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  modalData?: {}
}

const initialModalState: ModalInterface = {
  modalName: '',
  modalData: {}
}

const createModalStore = () => {
  const { subscribe, update } = writable(initialModalState);

  return {
    subscribe,
    setName: (modalName: string) => update((state) => ({ ...state, modalName})),
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    setData: (modalData: {}) => update((state) => ({ ...state, modalData}))
  }
}

export const modalStore = createModalStore();
